<a class="c-nav__close" href=""></a>
<header class="home-page">
  <div class="header-top d-none d-sm-block">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-between">
            <div class="d-inline-flex justify-content-between">
              <div class="pad20 adresse">
                <span class="icon-map"></span>300, lotissement Mandarona , Sidi
                Maârouf, 20270 Casablanca
              </div>
              <div class="pad20 phone">
                <span class="icon-phone"></span>(+212) 520 121 314
              </div>
              <div class="pad20 fax">
                <span class="icon-fax"></span>(+212) 522 786 102
              </div>
            </div>
            <div class="d-flex justify-content-between social-links">
              <a class="facebook" href="https://www.facebook.com/ANPMaroc"><img
                  src="assets/media/images/facebook-icon.svg" alt=""></a>
              <a class="linkedin" href="https://www.linkedin.com/company/agence-nationale-des-ports-maroc/"><img
                  src="assets/media/images/LinkedIn_icon_circle.svg" alt=""></a>
              <a class="twitter" href="https://twitter.com/AnpMaroc"><img src="assets/media/images/twitter-icon.svg"
                  alt=""></a>
              <a class="youtube" href="https://www.youtube.com/channel/UCDd_7d4_8ft8JPyIWhIw1eQ"><img
                  src="assets/media/images/youtube-icon.svg" alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <nav class="navbar navbar-expand-lg navbar-light bg-light" style="margin: 10px;">
    <a class="navbar-brand" href="javascript:void(0)" [routerLink]="['/']" routerLinkActive="router-link-active">
      <h1 class="logo">
        <img class="img-fluid" src="assets/media/images/logo.svg" alt="ANP" />
      </h1>
    </a>
    <div class="d-flex">
      <div class="nav-item lang-item dropdown d-block d-lg-none">
        <a class="nav-link dropdown-toggle" id="droplang" href="#" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">{{"langue.code" | translate}}</a>
        <div class="dropdown-menu" aria-labelledby="droplang">
          <a class="dropdown-item" (click)="translateto('fr')">Fr - Français</a>
          <a class="dropdown-item" (click)="translateto('en')">En - English</a>
          <a class="dropdown-item" (click)="translateto('ar')">Ar - عربي</a>
        </div>
      </div>
      <div class="nav-item search-item d-block d-lg-none"><a class="nav-link" routerLink="recherche">
          <span class="icon-search"></span></a></div>
      <div class="espace-pro dropdown d-block d-lg-none">
        <a class="nav-link" id="dropespacepro1" href="javascript:void(0)"
           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span class="icon-professional"></span>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropespacepro1">
          <span *ngFor="let Sitem of menuEspacePro">
            <a [class.toright]="langCode=='ar'" class="dropdown-item"
              *ngIf="(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) && !iseirect(Sitem.ApplicationUrl)"
              [routerLink]="[Sitem.ApplicationUrl]" href="javacript:void(0)">{{Sitem.Title}}</a>
            <a [class.toright]="langCode=='ar'" class="dropdown-item"
              *ngIf="!(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) "
              href="javacript:void(0)">{{Sitem.Title}}</a>
            <a [class.toright]="langCode=='ar'" class="dropdown-item"
              *ngIf="(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) && iseirect(Sitem.ApplicationUrl)"
              [href]="Sitem.ApplicationUrl">{{Sitem.Title}}</a>
          </span>
        </div>
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#nav-principal"
        aria-controls="nav-principal" aria-expanded="false" aria-label="Toggle navigation"><span
          class="navbar-toggler-icon"></span></button>
    </div>
    <div class="collapse navbar-collapse" id="nav-principal">
      <ul class="navbar-nav" [class.mr-auto]='langCode!="ar"' [class.ml-auto]='langCode=="ar"'>
        <li class="nav-item dropdown" *ngFor="let item of MenuNiveau0"
          [class.has-megamenu]="item.MegaMenu ==='Service' || item.MegaMenu === 'isMegaMenu'">
          <a *ngIf="getSousMenu(item.Id).length > 0" class="nav-link dropdown-toggle" id="dropagence"
            href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{item.Title}}
          </a>
          <a *ngIf="getSousMenu(item.Id).length === 0 && (item.ApplicationUrl !== null && item.ApplicationUrl !== undefined)"
            class="nav-link" href="javascript:void(0)" [routerLink]="[item.ApplicationUrl]"
            aria-expanded="false">{{item.Title}}
          </a>
          <a *ngIf="getSousMenu(item.Id).length === 0 && (item.ApplicationUrl === null || item.ApplicationUrl === undefined)"
            class="nav-link" href="javascript:void(0)" aria-expanded="false">{{item.Title}}</a>
          <div class="dropdown-menu" aria-labelledby="dropagence"
            *ngIf="item.MegaMenu !=='Service' && item.MegaMenu !== 'isMegaMenu'">
            <span *ngFor="let Sitem of getSousMenu(item.Id)">
              <a [class.toright]="langCode=='ar'" class="dropdown-item"
                *ngIf="(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) "
                [routerLink]="[Sitem.ApplicationUrl]" href="javacript:void(0)">{{Sitem.Title}}</a>
              <a [class.toright]="langCode=='ar'" class="dropdown-item"
                *ngIf="!(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) "
                href="javacript:void(0)">{{Sitem.Title}}</a>

            </span>

          </div>
          <div class="dropdown-menu megamenu" aria-labelledby="dropServices" *ngIf="item.MegaMenu ==='Service'">
            <div class="row" style="width: auto;">
              <div class="col-megamenu active" *ngFor="let Sitem of getSousMenu(item.Id)">
                <div class="h3 title">{{Sitem.Title}}</div>
                <ul class="list-unstyled">
                  <li *ngFor="let Siter of getSousMenu(Sitem.Id)">
                    <a [class.toright]="langCode=='ar'" class="dropdown-item"
                      *ngIf="Siter.ApplicationUrl !== null && Siter.ApplicationUrl !== undefined && !iseirect(Siter.ApplicationUrl)"
                      [routerLink]="[Siter.ApplicationUrl]" href="javacript:void(0)">{{Siter.Title}}</a>
                    <a [class.toright]="langCode=='ar'" class="dropdown-item"
                      *ngIf="!(Siter.ApplicationUrl !== null && Siter.ApplicationUrl !== undefined)"
                      href="javacript:void(0)">{{Siter.Title}}</a>
                    <a [class.toright]="langCode=='ar'" class="dropdown-item"
                      *ngIf="(Siter.ApplicationUrl !== null && Siter.ApplicationUrl !== undefined) && iseirect(Siter.ApplicationUrl)"
                      [href]="Siter.ApplicationUrl">{{Siter.Title}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="dropdown-menu megamenu pl-0 pr-0" aria-labelledby="dropPublications"
            *ngIf="item.MegaMenu ==='isMegaMenu'">
            <div class="d-flex">
              <div class="colonne">
                <div class="col-megamenu p-0 m-0">
                  <ul class="list-unstyled">
                    <li *ngFor="let Sitem of getSousMenu(item.Id);let index = index"
                      id="{{Sitem.MegaMenu !== 'CentreMedia' ? 'Pubid'+index : 'dropmedia'}}">
                      <a [class.toright]="langCode=='ar'" class="dropdown-item"
                        *ngIf="(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) && !iseirect(Sitem.ApplicationUrl)"
                        [routerLink]="[Sitem.ApplicationUrl]" href="javacript:void(0)">{{Sitem.Title}}</a>
                      <a [class.toright]="langCode=='ar'" class="dropdown-item"
                        *ngIf="!(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) "
                        href="javacript:void(0)">{{Sitem.Title}}</a>
                      <a [class.toright]="langCode=='ar'" class="dropdown-item"
                        *ngIf="(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) && iseirect(Sitem.ApplicationUrl)"
                        [href]="Sitem.ApplicationUrl">{{Sitem.Title}} aaa</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="colonne">
                <div class="soumenumedia">
                  <div class="d-flex">
                    <div class="phototheque flex-fill">
                      <div class="h4" [class.toright]="langCode=='ar'">{{"Phototheque" | translate}}</div>
                      <div class="slider-menu">
                        <div class="slide-item" *ngFor="let grp of topImages">
                          <div class="d-flex" *ngFor="let images of grp">
                            <div class="col" *ngFor="let item of images">
                              <a href="javascript:void(0)" class="CloseMenu"
                                [routerLink]="'/publications/phototheque/'+ item.title">
                                <img class="img-fluid" [src]="item.image" alt="ANP">
                                {{item.title}}
                              </a>
                            </div>

                          </div>

                        </div>

                      </div><a [class.text-right]="langCode ==='ar'" [class.text-left]="langCode!=='ar'"
                        class="btn btn-primary btn-abso-2 CloseMenu" href="javascript:void(0)"
                        [routerLink]="['/publications/centremedia']">{{"general.AfficherTout" | translate}}<span
                          class="icon-cheveron-right"></span></a>
                    </div>
                    <div class="videotheque flex-fill">
                      <div class="h4" [class.toright]="langCode=='ar'">{{"Videotheque" | translate}}</div>
                      <div class="slider-menu">
                        <div class="slide-item" *ngFor="let item of videos">
                          <a class="play-btn" href="javascript:void(0)" (click)="modal(item.youtube)">
                          </a>
                          <img [src]="'https://img.youtube.com/vi/'+item.youtube+'/default.jpg'" width="100%" />

                        </div>

                      </div><a [class.text-right]="langCode ==='ar'" [class.text-left]="langCode!=='ar'"
                        class="btn btn-primary  btn-abso-2 CloseMenu" href="javascript:void(0)"
                        [routerLink]="['/publications/centremedia']">{{"general.AfficherTout" | translate}}<span
                          class="icon-cheveron-right"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </li>
      </ul>
      <ul class="navbar-nav nav-right my-2 my-md-0">
        <li class="nav-item"><a class="nav-link" href="javascript:void(0)" [routerLink]="['/acces-rapide', 'contact']"
            routerLinkActive="router-link-active">{{'header.contact' | translate}} </a></li>
        <!-- <li class="nav-item"><a class="nav-link" href="https://reclamation.anp.org.ma"
            target="_blank">{{'header.reclamation' | translate}}</a></li> -->
        <li class="nav-item lang-item dropdown d-none d-md-block">
          <a class="nav-link dropdown-toggle" id="droplang" href="#" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">{{"langue.code" | translate}}</a>
          <div class="dropdown-menu" aria-labelledby="droplang">
            <a class="dropdown-item" (click)="translateto('fr')">Fr - Français</a>
            <a class="dropdown-item" (click)="translateto('en')">En - English</a>
            <a class="dropdown-item" (click)="translateto('ar')">Ar - عربي</a>
          </div>
        </li>
        <li class="nav-item search-item d-none d-md-block">
          <a class="nav-link" routerLink="recherche"><span class="icon-search"></span></a>
          <div class="modal fade" id="bloc-search" tabindex="-1" aria-labelledby="searchLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="searchLabel">Recherche</h5>
                  <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form class="form-inline my-2 my-md-0">
                    <div class="form-group">
                      <input class="form-control" [(ngModel)]="search" type="text" placeholder="Recherche" name="Recherche"/>
                      <button class="btn btn-link" (click)="Search()">
                        <span class="icon-long-right-arrow"></span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li *ngIf="menuEspacePro.length > 0" class="nav-item espace-pro dropdown d-none d-md-block">
          <a class="nav-link dropdown-toggle" id="dropespacepro" href="javascript:void(0)" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false"><span class="icon-professional"></span>{{'header.espace-pro' |
            translate}}</a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropespacepro">
            <span *ngFor="let Sitem of menuEspacePro">
              <a [class.toright]="langCode=='ar'" class="dropdown-item"
                *ngIf="(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) && !iseirect(Sitem.ApplicationUrl)"
                [routerLink]="[Sitem.ApplicationUrl]" href="javacript:void(0)">{{Sitem.Title}}</a>
              <a [class.toright]="langCode=='ar'" class="dropdown-item"
                *ngIf="!(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) "
                href="javacript:void(0)">{{Sitem.Title}}</a>
              <a [class.toright]="langCode=='ar'" class="dropdown-item"
                *ngIf="(Sitem.ApplicationUrl !== null && Sitem.ApplicationUrl !== undefined) && iseirect(Sitem.ApplicationUrl)"
                [href]="Sitem.ApplicationUrl">{{Sitem.Title}}</a>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>
<div class="modal fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  style="background-color: #84919ca1;" aria-hidden="true">
  <div class="modal-dialog" role="document" style="top: 20%;">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <!-- 16:9 aspect ratio -->
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" src="" id="video1" allowscriptaccess="always" allow="autoplay"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>